/* ============================================================
   NEW DESIGN FOOTER  —  assets/new-design-footer.js
   1) Mobile accordions (ek waqt me ek hi khulta hai)
   2) Mobile app popup:
        - customer ke aane ke X second baad show hota hai
        - close karne par band, aur usi session me dobara nahi aata
        - jab customer dobara HOME PAGE par aata hai to phir se show
   ============================================================ */

(function () {
  'use strict';

  var POPUP_KEY = 'ndFooterAppPopupClosed';

  /* ---------- 1. MOBILE ACCORDIONS ---------- */
  function initAccordions(root) {
    var triggers = root.querySelectorAll('.nd-footer__acc-trigger-mobile');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.dataset.ndBound === 'true') return;
      trigger.dataset.ndBound = 'true';

      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // pehle sab band karo (single-open behaviour)
        root.querySelectorAll('.nd-footer__acc-trigger-mobile').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
        root.querySelectorAll('.nd-footer__acc-panel-mobile').forEach(function (p) {
          p.classList.remove('is-open');
        });

        // phir clicked wala kholo (agar pehle se khula nahi tha)
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
    });
  }

  /* ---------- 2. MOBILE APP POPUP ---------- */
  function initAppPopup(root) {
    var popup = document.querySelector('[data-nd-apppop]');
    if (!popup || popup.dataset.ndBound === 'true') return;
    popup.dataset.ndBound = 'true';

    var closeBtn = popup.querySelector('[data-nd-apppop-close]');
    var isHome = root.getAttribute('data-is-home') === 'true';
    var delay = parseInt(root.getAttribute('data-popup-delay'), 10);
    var breakpoint = parseInt(root.getAttribute('data-popup-breakpoint'), 10);

    if (isNaN(delay)) delay = 3;
    if (isNaN(breakpoint)) breakpoint = 767;

    // sirf mobile par
    if (window.innerWidth > breakpoint) return;

    function readFlag() {
      try { return sessionStorage.getItem(POPUP_KEY); } catch (e) { return null; }
    }
    function writeFlag() {
      try { sessionStorage.setItem(POPUP_KEY, '1'); } catch (e) {}
    }
    function clearFlag() {
      try { sessionStorage.removeItem(POPUP_KEY); } catch (e) {}
    }

    // Home page par aane se flag reset ho jata hai -> popup dobara show hoga
    if (isHome) clearFlag();

    if (readFlag()) return;

    function show() {
      if (window.innerWidth > breakpoint) return;
      popup.removeAttribute('hidden');
      popup.classList.add('is-visible');
      document.body.classList.add('nd-footer-apppop-open');
      document.body.style.paddingBottom = popup.offsetHeight + 'px';
    }

    function hide() {
      popup.classList.remove('is-visible');
      popup.setAttribute('hidden', '');
      document.body.classList.remove('nd-footer-apppop-open');
      document.body.style.paddingBottom = '';
      writeFlag();
    }

    window.setTimeout(show, delay * 1000);

    if (closeBtn) {
      closeBtn.addEventListener('click', hide);
    }

    // store link click karne par bhi band kar do
    popup.querySelectorAll('.nd-footer-apppop__store').forEach(function (a) {
      a.addEventListener('click', hide);
    });

    // window resize par desktop ho jaye to hide
    window.addEventListener('resize', function () {
      if (window.innerWidth > breakpoint && popup.classList.contains('is-visible')) {
        popup.classList.remove('is-visible');
        popup.setAttribute('hidden', '');
        document.body.classList.remove('nd-footer-apppop-open');
        document.body.style.paddingBottom = '';
      }
    });
  }

  /* ---------- INIT ---------- */
  function init() {
    var roots = document.querySelectorAll('[data-nd-footer]');
    roots.forEach(function (root) {
      initAccordions(root);
      initAppPopup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor me section reload hone par dobara bind
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-nd-footer]')) {
      init();
    }
  });
})();